import { Request } from "../request";
 

 
 //获取ip
export function getip(params) { 
    return Request.http.post("/art/app/getip", params);
}


//登录  
export function appLogin(params) { 
    return Request.http.post("/art/app/login", params);
}
//账号申请 
export function appRegister(params) { 
    return Request.http.post("/art/app/register", params);
}
//获取用户信息
export function getUserInfo(params) { 
    return Request.http.get("/art/app/index/userInfo", params);
}
 
//首页列表
export function indexList(params) { 
    return Request.http.get("/art/app/index/list", params);
}
//年代
export function indexYears(params) { 
    return Request.http.get("/art/app/index/years", params);
}
//出处
export function indexFrom(params) { 
    return Request.http.get("/art/app/index/from", params);
}
//类别
export function indexClass(params) { 
    return Request.http.get(`/art/app/index/class/${params.id}`, params);
}
//类别 all
export function indexBookclass(params) { 
    return Request.http.get(`/art/arts/bookclass/all`, params);
}
//获取书架
export function indexBag(params) { 
    return Request.http.get(`/art/app/index/bag`, params);
}


//获取书的详情
export function chapterDetail(params) { 
    return Request.http.get(`/art/app/index/chapter`, params);
}



//记录查看册名,传chapteid即可,这个只统计册
export function setDoRecord(params) { 
    return Request.http.get(`/art/app/index/doRecord/${params.id}`, params);
}
